import React from 'react';
import { CircularProgress } from '@mui/material';

import theme from '../../../utils/theme';

const Loading = ({ color = theme.primaryButton, ...rest }) => <CircularProgress sx={{ color }} {...rest} />;

export default Loading;
